<section>
  <div class="pagination-info">
    Showing {{ startItem }} - {{ endItem }} of {{ totalElements }}
  </div>
  
  <div class="pagination">
    <button
      type="button"
      (click)="previous()"
      [disabled]="!hasPrevious">
      <img src="/misc/previous.svg" alt="previous icon">
    </button>

    @for (item of pages; track $index) {

      @if (item === '...') {
        <span>...</span>
      } @else {
        <button
          type="button"
          class="page-number"
          (click)="goTo(+item)"
          [class.active]="item === page">

          {{ item }}

        </button>
      }

    }

    <button
      type="button"
      (click)="next()"
      [disabled]="!hasNext">
      <img src="/misc/next.svg" alt="next icon">
    </button>
  </div>
</section>
